// CustomSwitch.js
import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';

const CustomSwitch = ({ defaultChecked, color, label, required, tooltipText }) => {
  const [isChecked, setChecked] = useState(defaultChecked || false);

  const switchColor = isChecked ? color : 'default';
  const trackColor = isChecked ? 'secondary' : 'default';
  const trackColor1 = isChecked ? 'warning' : 'default';

  const renderLabel = () => {
    if (!label) {
      return null;
    }

    const capitalizedLabel = label
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    return (
      <>
        {capitalizedLabel}
        {required && <span style={{ color: 'red' }}>*</span>}
      </>
    );
  };

  const handleSwitchChange = () => {
    setChecked(!isChecked);
  };

  return (
    <div>
      <FormControlLabel
        control={
          <Tooltip title={tooltipText} placement="top" arrow>
            <Switch
              checked={isChecked}
              onChange={handleSwitchChange}
              color={switchColor}
              sx={{
                '& .MuiSwitch-thumb': {
                  backgroundColor: isChecked ? trackColor : trackColor1,
                },
              }}
            />
          </Tooltip>
        }
        label={renderLabel()}
        labelPlacement="start"
      />
      {isChecked ? 1 : 0}
    </div>
  );
};

export default CustomSwitch;
